<template>
    <div class="vibrant-rubik-cube">
        <base-form ref="baseForm"></base-form>
        <div ref="testDIV"  class="btn-tool align-center">
            <Button ref="testBotton" type="ghost" @click="handleClose()" style="margin-left: 8px">{{$t('com.btn.close')}}</Button>
            <Button type="primary" v-on:click.stop="save('formCustom')">{{$t('com.btn.save')}}</Button>
        </div>
    </div>
</template>


<script>
import BaseForm from './form'

export default {
    components: { BaseForm},
    props:{tabelSelect:Object},
    data () {
        return {
        }
    },
    created(){
    },
    //初始化后调用
    mounted:function(){
    },
    methods: {
        //保存
        save () {
          
            let self=this;
            let pse=this.$refs.baseForm.getFormData('formCustom')
            pse.then( function(formCustom){
                self.$api.post('fundAccount/addFundAccount', formCustom, r => {
                    self.$utils.tips.aSuccess;
                    //刷新list页面列表
                    self.$emit('handleSubmit', "formCustom");
                    self.handleClose();
                },null,"finance")
            },reject=>{})
        },
        
        //关闭
        handleClose () {
            let tabItemName=this.$parent.name;
            this.$emit('handleClose', tabItemName);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/add.vue